import React, { useEffect } from 'react';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import lodash from 'lodash';
import { useGetGroundWaterZones } from '../../../../hooks/query/borehole/masterData/groundWaterZoneQueries';
import { IGroundWaterZone } from '../../../../@types/model/borehole/groundWaterZone/groundWaterZone';

interface IBoreholeGroundwaterZoneSelectorProps {
    valueCode : string | null;

    onChange : (value : IGroundWaterZone | null) => void;

    disabled ?: boolean;
    required ?: boolean;
}

const BoreholeGroundwaterZoneSelectorComponent = (props : IBoreholeGroundwaterZoneSelectorProps) => {
        const { isLoading: isLoadingGroundWaterZones, data: groundWaterZones } = useGetGroundWaterZones();
        
        useEffect(() => {
            
        }, [ isLoadingGroundWaterZones ]);

        const onChange = (event : React.ChangeEvent<{
            name ?: string | undefined;
            value : unknown;
        }>) => {
            const zone = groundWaterZones?.slice().find(n => n.code === event.target.value);
            props.onChange(zone ?? null);
        };

        return (
            <FormControl
                margin='normal'
                required={props.required}
                fullWidth>
                <InputLabel
                    shrink={!!props.valueCode}
                    htmlFor='value'>
                        Groundwater Zone
                </InputLabel>
                <Select
                    fullWidth
                    required={props.required}
                    disabled={isLoadingGroundWaterZones || props.disabled}
                    id='value'
                    value={props.valueCode ?? ''}
                    onChange={onChange}
                >
                    {
                        !props.required &&
                        <MenuItem key={'None'} value={'None'}>
                            None
                        </MenuItem>
                    }
                    {
                        lodash.map(groundWaterZones, n => (
                            <MenuItem
                                key={`${n.code}_zone`}
                                value={`${n.code}`}
                            >
                                {n.code} - {n.name}
                            </MenuItem>
                        ))
                    }
                </Select>
            </FormControl>
        );
}

export default BoreholeGroundwaterZoneSelectorComponent;
